import moment from 'moment';

export const formattedDate = (date, format = 'D MMM YYYY') =>
  date && moment(date).isValid() ? moment(date).format(format) : null;

export const fromNow = (date) =>
  date && moment(date).isValid()
    ? moment.utc(date).local().startOf('seconds').fromNow()
    : null;

export const getYear = (date) => formattedDate(date, 'YYYY');

export const getMonth = (date) => formattedDate(date, 'MM');

export const createDate = (year, month, day = 1) =>
  new Date(year, month - 1, day);

export const formatNorwegianDate = (dateString) => {
  const date = new Date(dateString);
  const now = new Date();

  const diffMs = now - date;
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffHours < 1) {
    return 'akkurat nå';
  }

  if (diffHours < 24) {
    return diffHours === 1 ? '1 time siden' : `${diffHours} timer siden`;
  }

  if (diffDays < 7) {
    if (diffDays === 1) return 'Én dag siden';
    if (diffDays === 2) return 'To dager siden';
    return `${diffDays} dager siden`;
  }

  return date.toLocaleDateString('no-NO', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
};
